// src/components/Results/TypeIcon.js
// Centralised mapping from typeDef.iconKey → Lucide icon component.
// Replaces the cheesy emoji icons with clean editorial iconography.

import React from 'react';
import { Compass, Flame, Sparkles, Network, Ruler, Anchor } from 'lucide-react';

const ICON_MAP = {
  Compass,
  Flame,
  Sparkles,
  Network,
  Ruler,
  Anchor,
};

/**
 * Render the Lucide icon associated with a type's iconKey.
 * Falls back to Compass if the key is missing/unknown.
 *
 * @param {string} iconKey - One of the keys in ICON_MAP
 * @param {number} size - Pixel size (default 24)
 * @param {string} className - Tailwind classes for color/positioning
 * @param {number} strokeWidth - Default 1.75 (slightly lighter than Lucide default)
 */
function TypeIcon({ iconKey, size = 24, className = '', strokeWidth = 1.75 }) {
  const Icon = ICON_MAP[iconKey] || Compass;
  return <Icon size={size} className={className} strokeWidth={strokeWidth} />;
}

export default TypeIcon;
export { ICON_MAP };
